import React, { memo } from "react";
import { useNavigate } from "react-router-dom";
import { Profile } from "@/models/database/profiles/profile.model";
import { Avatar, Box, Card, Flex, Text, Button } from "@radix-ui/themes";

const NavigationBarAvatar: React.FunctionComponent<{
  isPlaceholder?: boolean;
  closeWindow?: () => void;
  profile: Profile;
}> = ({ profile, closeWindow }) => {
  const navigate = useNavigate();

  function handleNavigate() {
    // closeWindow();
    try {
      navigate("/profile");
    } catch (error) {
      console.error("Error navigating to profile page", error);
    } finally {
      closeWindow;
    }
  }

  return (
    <Box onClick={handleNavigate} className="header__user">
      <Flex gap="3" align="center">
        <Avatar
          src={profile.profileLogoUrl}
          fallback="A"
          radius="full"
          size="3"
        />
        <Box>
          <Text as="div" size="2" weight="bold" truncate>
            {profile?.userName}
          </Text>
          <Text as="div" size="2" color="gray" truncate>
            {profile?.fullName}
          </Text>
        </Box>
      </Flex>
    </Box>
  );
};

export default memo(NavigationBarAvatar);
